import { render, staticRenderFns } from "./choose_me_tags.vue?vue&type=template&id=1449b58d&scoped=true&"
import script from "./choose_me_tags.vue?vue&type=script&lang=js&"
export * from "./choose_me_tags.vue?vue&type=script&lang=js&"
import style0 from "./choose_me_tags.vue?vue&type=style&index=0&id=1449b58d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1449b58d",
  null
  
)

export default component.exports